<template>
  <v-container>
    <v-row v-if="!has_error">
      <v-col xs="12"
             offset-sm="1" sm="10"
             offset-md="3" md="6"
             offset-lg="4" lg="4"
             offset-xl="4" xl="4">
        <div v-if="loading" class="text-center">{{ $vuetify.lang.t('$vuetify.tag_code_scanner.global.loading_stream') }}</div>
        <qrcode-stream @decode="onDecode" @init="onInit"></qrcode-stream>
      </v-col>
    </v-row>
    <v-row>
      <v-col offset="1" cols="10" class="text-center">
        <div v-if="has_error">
          <p  class="error mb-3 text-center">{{ error }}</p>
          <v-btn color="error" v-if="displayExitBtnOnError" dark target="_blank" @click="clickErrorClosed">
            {{button_text_error}}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import {QrcodeStream} from "vue-qrcode-reader";

export default {
  name: "SharedQrCodeScannerComponent",
  props : {
    displayExitBtnOnError : {
      type : Boolean,
      default : false,
    },
    errorBtnText : {
      type : String,
    }
  },
  components: {
   QrcodeStream
  },
  data (){
    return {
      has_error : false,
      error: '',
      loading : true,
      button_text_error : ''
    }
  },
  methods : {

    onDecode (decodedString) {
      // ...
      this.$emit('decodedQr', decodedString);
    },
    clickErrorClosed(){
      this.$emit('closedScannerError');
    },
    async onInit (promise) {
      try {
        await promise
        this.loading = false;
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          //ERROR: you need to grant camera access permisson
          this.error = this.$vuetify.lang.t('$vuetify.errors.camera.NotAllowedError')
        } else if (error.name === 'NotFoundError') {
          //ERROR: no camera on this device
          this.error = this.$vuetify.lang.t('$vuetify.errors.camera.NotFoundError')
        } else if (error.name === 'NotSupportedError') {
          //ERROR: secure context required (HTTPS, localhost)
          this.error = this.$vuetify.lang.t('$vuetify.errors.camera.NotSupportedError')
        } else if (error.name === 'NotReadableError') {
          //ERROR: is the camera already in use?
          this.error = this.$vuetify.lang.t('$vuetify.errors.camera.NotReadableError')
        } else if (error.name === 'OverconstrainedError') {
          //ERROR: installed cameras are not suitable
          this.error = this.$vuetify.lang.t('$vuetify.errors.camera.OverconstrainedError')
        } else if (error.name === 'StreamApiNotSupportedError') {
          //ERROR: Stream API is not supported in this browser
          this.error = this.$vuetify.lang.t('$vuetify.errors.camera.StreamApiNotSupportedError')
        }
        this.has_error = true;
        this.$emit('criticalError', true)
      }
    }
  },
  mounted() {
    if(this.errorBtnText !== undefined && this.errorBtnText !== null && this.errorBtnText.length >=1){
      this.button_text_error = this.errorBtnText
    }else{
      this.button_text_error = this.$vuetify.lang.t('$vuetify.tag_code_scanner.global.default_error_button_test');
    }
  }
}
</script>

<style scoped>
  p.error {
    padding : 12px;
    color: white;
  }
</style>